import { render, staticRenderFns } from "./StandardKeyboardHandler.vue?vue&type=template&id=8b846dd4&"
import script from "./StandardKeyboardHandler.vue?vue&type=script&lang=ts&"
export * from "./StandardKeyboardHandler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports